export const ROUTES = {
  root: "/",
  login: "/login/",
  about: "/about/",
  dashboard: "/dashboard/",
  realtime: "/realtime-data/",
  static: "/static-data/",
  terms: "/terms-and-conditions/",
  gtfs: "/what-is-gtfs/",
};

export const WIDGET_DISPLAY_TYPES = {
  map: "map",
  table: "table",
};

export const LANGUAGES = {
  "kn": "ಕನ್ನಡ",
  "en": "ENG",
};

export const DATA_FETCHGING_STATUSES = {
  PENDING: "PENDING",
  PROGRESS: "PROGRESS",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const BACKEND_HOST =  import.meta.env.VITE_PUBLIC_BACKEND_HOST;
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export const FORM_STATUSES = {
  INITIAL: "INITIAL",
  SUBMITTING: "SUBMITTING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const getDownloadFileLink = (bmtc, bmrcl) => {
  if(bmtc && bmrcl) {
    return "/gtfs-19-07-2024_1.zip";
  } else if(bmtc) {
    return "/bmtc-19-07-2024.zip";
  } else {
    return "/bmrcl-19-07-2024.zip";
  }
};

export const getQueryStringParam = (sParam) => {
  if(typeof window !== "undefined") {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');

    for (let i = 0; i < sURLVariables.length; i++) {
      const sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1];
      }
    }
  }
};

export const setQueryStringParam = (paramName, paramValue) => {
  if(typeof window !== "undefined") {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set(paramName, paramValue);
    window.history.replaceState({}, document.title, newUrl.href);
  }
}

export const MAX_FONTSIZE = 28;
export const MIN_FONTSIZE = 12;

export const COMMON_TRANSLATIONS = {
  en: {
    home: "Home",
    login: "Login",
    learn: "LEARN MORE",
    static: "Static Data",
    realtime: "Realtime Data",
    gtfs: "What is GTFS?",
    about: "About",
    waitlist: "Join waitlist",
  },
  kn: {
    home: "Home",
    login: "ಲಾಗಿನ್",
    learn: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    static: "ಸ್ಟಾಟಿಕ್ ಡೇಟಾ",
    realtime: "ರಿಯಲ್ ಟೈಮ್  ಡೇಟಾ",
    gtfs: "GTFS ಎಂದರೇನು?",
    about: "ಬಗ್ಗೆ",
    waitlist: "ಕಾಯುವಿಕೆ ಪಟ್ಟಿಗೆ ಸೇರಿಕೊಳ್ಳಿ",
  }
}
